export default __webpack_public_path__ + "static/media/domore-cover.a44f45b8.png";